/**
 * 模拟接口
 */
import http from '../http';
import Qs from 'qs';

export default {

};
